<template>
    <v-form
        data-vv-scope="newPersonEmploymentForm"
    >
        <v-select
            :error-messages="newPersonEmploymentEcsCompanyIdErrors"
            :items="ecsCompanyList"
            @blur="$v.newPersonEmploymentEcsCompanyId.$touch()"
            @input="$v.newPersonEmploymentEcsCompanyId.$touch()"
            item-text="name"

            item-value="ecsCompanyId"
            label="ECS Company"
            v-model="newPersonEmploymentEcsCompanyId"
        />

        <v-autocomplete
            :error-messages="newPersonEmploymentJobIdErrors"
            :items="liveJobList"
            @blur="$v.newPersonEmploymentJobId.$touch()"
            @input="$v.newPersonEmploymentJobId.$touch()"
            item-text="name"

            item-value="jobId"
            label="Job"
            v-model="newPersonEmploymentJobId"
        />

        <v-select
            :error-messages="newPersonEmploymentTypeIdErrors"
            :items="employmentTypeList"
            @blur="$v.newPersonEmploymentTypeId.$touch()"
            @input="$v.newPersonEmploymentTypeId.$touch()"
            item-text="name"

            item-value="employmentTypeId"
            label="Employment Type"
            v-model="newPersonEmploymentTypeId"
        />
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="290px"
            offset-y
            transition="scale-transition"

            v-model="startDateMenu"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    :error-messages="newPersonEmploymentStartDateErrors"
                    @blur="$v.newPersonEmploymentStartDate.$touch()"
                    @input="menu2 = false && $v.newPersonEmploymentStartDate.$touch()"
                    label="Start Date"
                    readonly

                    slot="activator"
                    v-model="newPersonEmploymentStartDate"
                    v-on="on"
                />
            </template>
            <v-date-picker
                :error-messages="newPersonEmploymentStartDateErrors"

                @blur="$v.newPersonEmploymentStartDate.$touch()"
                @input="startDateMenu = false && $v.newPersonEmploymentStartDate.$touch()"
                v-model="newPersonEmploymentStartDate"
            />
        </v-menu>
        <v-select
            :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
            @blur="$v.newPersonEmploymentIsAllowedToil.$touch()"
            @input="$v.newPersonEmploymentIsAllowedToil.$touch()"
            item-text="name"
            item-value="Id"
            label="Allowed TOIL"
            v-model="newPersonEmploymentIsAllowedToil"
        />
        <v-select
            :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
            @blur="$v.newPersonEmploymentIsAllowedExpenses.$touch()"
            @input="$v.newPersonEmploymentIsAllowedExpenses.$touch()"
            item-text="name"
            item-value="Id"
            label="Allowed Expenses"
            v-model="newPersonEmploymentIsAllowedExpenses"
        />
        <!--    <v-btn @click="changeStep(-1)">Previous</v-btn>-->
        <!--    <v-btn @click="changeStep(+1)">Next</v-btn>-->
    </v-form>
</template>

<script>
    import {mapGetters} from "vuex";
    import {FETCH_JOB_LIST,} from "@/store/job/actions";
    import {FETCH_EMPLOYMENT_TYPES} from "@/store/employment_type/actions";
    import {FETCH_ECS_COMPANY_LIST} from "@/store/ecs_company/actions";
    import {required,} from 'vuelidate/lib/validators'

    import {SET_NEW_PERSON_FORM_SECTION_STATE, UPDATE_NEW_PERSON} from "@/store/person/mutations";


    export default {
        name: "Employment",

        validations: {
            newPersonEmploymentJobId: {required},
            newPersonEmploymentEcsCompanyId: {required},
            newPersonEmploymentTypeId: {required},
            newPersonEmploymentStartDate: {required}
        },

        data: function () {
            return {
                startDateMenu: false,
            }
        },

        computed: {

            newPersonEmploymentJobId: {
                get() {
                    return this.$store.state.person.newPerson.employments[0].jobId;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'employments';
                    data.key = 'jobId';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmploymentJobIdErrors() {
                const errors = [];
                if (!this.$v.newPersonEmploymentJobId.$dirty) return errors;
                !this.$v.newPersonEmploymentJobId.required && errors.push('Required.');
                return errors
            },

            newPersonEmploymentEcsCompanyId: {
                get() {
                    return this.$store.state.person.newPerson.employments[0].ecsCompanyId;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'employments';
                    data.key = 'ecsCompanyId';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmploymentEcsCompanyIdErrors() {
                const errors = [];
                if (!this.$v.newPersonEmploymentEcsCompanyId.$dirty) return errors;
                !this.$v.newPersonEmploymentEcsCompanyId.required && errors.push('Required.');
                return errors
            },

            newPersonEmploymentTypeId: {
                get() {
                    return this.$store.state.person.newPerson.employments[0].employmentTypeId;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'employments';
                    data.key = 'employmentTypeId';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmploymentTypeIdErrors() {
                const errors = [];
                if (!this.$v.newPersonEmploymentTypeId.$dirty) return errors;
                !this.$v.newPersonEmploymentTypeId.required && errors.push('Required.');
                return errors
            },

            newPersonEmploymentStartDate: {
                get() {
                    return this.$store.state.person.newPerson.employments[0].startDate;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'employments';
                    data.key = 'startDate';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmploymentStartDateErrors() {
                const errors = [];
                if (!this.$v.newPersonEmploymentStartDate.$dirty) return errors;
                !this.$v.newPersonEmploymentStartDate.required && errors.push('Required.');
                return errors
            },

            newPersonEmploymentIsAllowedToil: {
                get() {
                    return this.$store.state.person.newPerson.employments[0].isAllowedToil;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'employments';
                    data.key = 'isAllowedToil';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                },
            },
            newPersonEmploymentIsAllowedExpenses: {
                get() {
                    return this.$store.state.person.newPerson.employments[0].isAllowedExpenses;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'employments';
                    data.key = 'isAllowedExpenses';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                },
            },

            ...mapGetters([
                "ecsCompanyList",
                "liveJobList",
                "employmentTypeList",
            ])
        },

        mounted: function () {
            this.fetchEcsCompanies();
            this.fetchJobs();
            this.fetchEmploymentTypes();
        },

        methods: {
            fetchEcsCompanies() {
                this.$store.dispatch(FETCH_ECS_COMPANY_LIST);
            },
            fetchJobs() {
                this.$store.dispatch(FETCH_JOB_LIST);
            },
            fetchEmploymentTypes() {
                this.$store.dispatch(FETCH_EMPLOYMENT_TYPES);
            },
            validate() {

                this.$v.$touch();

                let formState = false;


                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'employment', state: formState});
            },
        }
    }
</script>

<style scoped>

</style>
